import { createAction } from '@reduxjs/toolkit';

const resetState = createAction('RESET')

export {
    resetState
};
